<template>
  <transition name="custom-modal">
    <div class="modal__mask">
      <div class="modal__wrapper">
        <div class="modal__container" :class="{ loading: type === 'loading' }">
          <div v-if="closeIconNew && closeable" class="close-icon-new" @click="$emit('close')">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect
                width="1.73753"
                height="18.7617"
                rx="0.868766"
                transform="matrix(0.690171 -0.723646 0.685263 0.728296 0.757812 1.25745)"
                fill="#747474"
              />
              <rect
                width="1.73231"
                height="18.7583"
                rx="0.866156"
                transform="matrix(0.68772 0.725976 -0.68772 0.725976 12.9004 0)"
                fill="#747474"
              />
            </svg>
          </div>
          <div v-else>
            <div class="modal__close" v-if="closeable" @click="$emit('close')">
              <i class="icon icon-times"></i>
            </div>
          </div>
          <br>
          <div class="modal__header" :class="{ 'modal-header-color': modalHeaderColor }">
            <slot name="header"></slot>
          </div>
          <div class="modal__body" :class="{ 'custom-modal-body': customModalBody }">
            <slot name="body"></slot>
          </div>
          <div class="modal__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
      <template v-if="type && type === 'success' && $route.matched[0] && $route.matched[0].name === 'deposit'">
        <component :is="'script'">
          fbq('track', 'Purchase', {currency: "EUR", value: 0.00});
        </component>
        <!-- Twitter single-event website tag code -->
        <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
        <component :is="'script'" type="text/javascript"
          >twttr.conversion.trackPid('o4rwi', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
        >
        <noscript>
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="https://analytics.twitter.com/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="//t.co/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
        </noscript>
        <!-- End Twitter single-event website tag code -->

        <!-- Twitter single-event website tag code -->
        <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
        <component :is="'script'" type="text/javascript"
          >twttr.conversion.trackPid('o4s1z', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
        >
        <noscript>
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="https://analytics.twitter.com/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="//t.co/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
        </noscript>
        <!-- End Twitter single-event website tag code -->
      </template>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['type', 'closeable', 'closeIconNew', 'modalHeaderColor', 'customModalBody'],
  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
};
</script>

<style lang="scss" scoped>
.modal__mask {
  position: fixed !important;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-height: -moz-available; /* WebKit-based browsers will ignore this. */
  min-height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  min-height: fill-available;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__wrapper {
  display: flex;
  max-height: 80%;
}

.modal__container {
  overflow-y: unset !important;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 410px;
  min-width: 410px;
  margin: 0 auto;
  background-color: #FFFFFF;
  transition: all 0.3s ease;
  padding: 0;
  color: var(--textColor9);
  position: relative;
  @media (min-width: 768px) {
    justify-content: flex-start;
    border-radius: 8px;
    max-height: 80vh;
    overflow-y: auto;
  }
  p,
  li {
    text-align: left;
    font-size: 14px;
    letter-spacing: 0px;
    color: #747474;
    line-height: normal;
  }
  ul {
    padding: 0 0 0 20px;
  }

  .icon {
    color: var(--textColor9) !important;
  }

  .modal__lg & {
    width: 70%;
  }
}

.modal__header {
  background-color: #e8e8e8;
  text-align: center;
  width: 100%;
  padding: 20px 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  .description {
    font-size: 15px;
    letter-spacing: 0;
    font-weight: bold;
    color: var(--color9);
    margin-top: 4px;
  }
  .title {
    color: var(--color3);
    text-transform: uppercase;
    letter-spacing: 0;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    @media (max-width: 768px) {
      font-size: 14px !important;
    }
  }
  @media (max-width: 768px) {
    .modal__icon {
      width: 60px;
      height: 60px;
    }
  }
}

.modal__body {
  padding: 20px;
  margin: 0;
  background: #fff;
  height: 100%;
  max-height: -webkit-fill-available;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  h1,
  h2,
  h3 {
    font-size: 1.2rem;
  }

  @media (max-width: 767px) {
    h1,
    h2,
    h3 {
      font-size: 1.2rem;
    }
  }
  @media (max-width: 768px) {
    .modal__icon {
      width: 60px;
      height: 60px;
    }
  }
}

.modal__close {
  position: absolute;
  border: 3px solid #fff;
  border-radius: 100%;
  line-height: 15px;
  font-size: 15px;
  padding: 7px;
  top: -15px;
  right: -15px;
  cursor: pointer;
  font-weight: 500;
  z-index: 20;
  background: #fff;

  .icon-times {
    color: var(--textColor9);
    font-weight: bold;
  }
  @media screen and (max-width: 480px) {
    top: 15px;
    right: 5px;
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal__container,
.modal-leave-active .modal__container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal__icon {
  width: 90px;
  height: 90px;
  &.loading {
    width: 50px;
    height: 50px;
  }
}

@media only screen and (max-width: 480px) {
  .modal__mask {
    display: block !important;
    overflow: hidden;
  }
  .modal__wrapper {
    max-height: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    padding: 0 !important;
  }
  .modal__container {
    min-width: 100%;
    width: 100%;
    display: flex;
    margin: 0 !important;
    flex: 1;
    overflow: hidden;
  }
}

@-o-viewport {
  maximum-scale: 1;
  user-scalable: no;
}
@-ms-viewport {
  maximum-scale: 1;
  user-scalable: no;
}

.close-icon-new {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 13px;
  top: 13px;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  .icon {
    font-size: 16px;
  }
}

.modal-header-color {
  background-color: #ffffff !important;
  padding: 20px 0 0 0 !important;
}

.custom-modal-body {
  padding: 7px 7px 10px 7px !important;
}
</style>
